
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { useTranslation } from "react-i18next";
import { UseFormReturn } from "react-hook-form";

interface ClassModeSelectProps {
  form: UseFormReturn<any>;
}

export const ClassModeSelect = ({ form }: ClassModeSelectProps) => {
  const { t } = useTranslation(['schedule']);

  return (
    <FormField
      control={form.control}
      name="mode"
      render={({ field }) => (
        <FormItem className="space-y-3">
          <FormLabel>{t('schedule:class.selectMode', 'Select Mode')}</FormLabel>
          <FormControl>
            <RadioGroup
              onValueChange={field.onChange}
              defaultValue={field.value}
              className="flex flex-col space-y-1"
            >
              <FormItem className="flex items-center space-x-3 space-y-0">
                <FormControl>
                  <RadioGroupItem value="existing" />
                </FormControl>
                <FormLabel className="font-normal">
                  {t('schedule:class.existingCourse', 'Use Existing Course')}
                </FormLabel>
              </FormItem>
              <FormItem className="flex items-center space-x-3 space-y-0">
                <FormControl>
                  <RadioGroupItem value="new" />
                </FormControl>
                <FormLabel className="font-normal">
                  {t('schedule:class.newCourse', 'Create New Course')}
                </FormLabel>
              </FormItem>
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
